import { useState, useCallback } from "react";
import geoFetch from "../../../../utils/geoFetch";
import { fnDivideFeature } from "../../../../utils/fnDivideFeature";

export const useGeolocation = () => {
  const [loading, setLoading] = useState(false);

  const getAddressByCoords = useCallback(async (lat, lng) => {
    setLoading(true);
    try {
      const { data } = await geoFetch(`${lng},${lat}.json`, { params: { limit: 1 } });

      if (data.features?.length > 0) {
        const parsed = fnDivideFeature(data.features[0]);
        setLoading(false);
        return {
          direccionCompleta: parsed.direccionOrigen || "",
          estado: parsed.estadoOrigen || "",
          municipio: parsed.municipioOrigen || "",
          cp: parsed.cpOrigen || "",
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        };
      }

      setLoading(false);
      return null;
    } catch (error) {
      console.error("Error en geocoding:", error);
      setLoading(false);
      return null;
    }
  }, []);

  return { getAddressByCoords, loading };
};
